import React from "react";
import Tab, { TabGroup } from "@amzn/meridian/tab";
import { PlanGroupSegment } from "../../admin-api/generated-src";
import { formatSegment } from "./segmentTime";
import { OVERALL_SEGMENT_ID } from "../../constants";

interface SegmentTabsProps {
  segments: PlanGroupSegment[];
  selectedSegmentId: string;
  onTabChange: (segmentId: string) => void;
  /** Facility UTC offset (minutes) for rendering segment times; null → UTC. */
  offsetMinutes?: number | null;
}

export default function SegmentTabs({
  segments,
  selectedSegmentId,
  onTabChange,
  offsetMinutes = null,
}: SegmentTabsProps) {
  return (
    <TabGroup value={selectedSegmentId} onChange={onTabChange}>
      <Tab value={OVERALL_SEGMENT_ID}>Overall</Tab>
      {segments.map((seg) => (
        <Tab key={seg.segmentId} value={seg.segmentId || ""}>
          {formatSegment(seg, offsetMinutes)}
        </Tab>
      ))}
    </TabGroup>
  );
}
